import React, { useEffect, useState } from 'react';
import ImageWithBasePath from '../../core/common/imageWithBasePath';
import { Link } from 'react-router-dom';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { all_routes } from '../router/all_routes';
import Pagination from '../StudyDestination/Australia/Pagination';
import { useGetGlobalPartnersuserPaginationQuery } from '../../core/Features/api/studyEssential/educationalLoan/educationLoan';

interface BannerProps {
    apiValues1: any,
    destinationId: any

}



const Whatsnew: React.FC<BannerProps> = ({ apiValues1, destinationId }) => {

    const route = all_routes;


    const [page, setPage] = useState(1);
    const limit = 3; // item per page
    const { data: apiValue, isLoading, isError } = useGetGlobalPartnersuserPaginationQuery({ page, limit, destinationId });



    const universities = apiValue?.data || [];
    // const totalItems = apiValue?.totalItems || 0;
    const totalPages = Math.ceil(apiValue?.totalPages || 1);
    const [selectedItems, setSelectedItems] = useState<boolean[]>([]);

    useEffect(() => {
        if (universities.length) {
            setSelectedItems(Array(universities.length).fill(false));
        }
    }, [universities]);

    const handleItemClick = (index: number) => {
        setSelectedItems((prev) => {
            const updated = [...prev];
            updated[index] = !updated[index];
            return updated;
        });
    };



    return (
        <>
            <div className="container feature-section position-relative pb-4">
                <div className="container">
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-01.png"
                        alt="img"
                        className="bg-star-01 img-fluid"
                    />
                    <ImageWithBasePath
                        src="assets/img/bg/feature-bg-02.png"
                        alt="img"
                        className="bg-star-02 img-fluid"
                    />


                    <div className="section-header text-start p-3">
                        <span className="section-badge">
                            {apiValues1?.title}
                        </span>
                        <h2>
                            {apiValues1?.description}
                        </h2>
                        <p>
                            {apiValues1?.miniDescription}
                        </p>
                    </div>

                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    {(Array.isArray(universities) ? universities : []).map((univ: any, index: number) => (
                        <div key={index} className="flex">
                            <div className="course-item-two course-item flex flex-col w-full h-full">
                                <div className="w-full h-36  rounded-lg"
                                    style={{
                                        backgroundImage: `url(${univ.imageUrl})`,
                                        backgroundRepeat: "no-repeat",
                                        backgroundSize: "100% 100%",
                                    }}
                                >
                                    {/* <Link to="#">
                                        <ImageWithBasePath style={{
                                            height:"250px",
                                            width:"100%"
                                        }}
                                            source={univ.imageUrl}
                                            alt="img"
                                            className="img-fluid"
                                        />
                                    </Link> */}
                                </div>

                                <div className="course-content text-start flex-grow mt-1">
                                    <div className="ms-2">
                                        <h5 className="subs-title mb-3">{univ.title}</h5>
                                        {(Array.isArray(univ?.tags) ? univ?.tags : []).map((item: any, idx: number) => (
                                            <p key={idx} className="mb-2">{item}</p>
                                        ))}
                                    </div>
                                </div>

                                <div className="border-b w-full mb-3" />

                                <div className="mb-3">
                                    <h6 className="mb-3">{univ?.availableText}</h6>
                                    <div className="flex flex-wrap gap-3 mb-3">
                                        {(Array.isArray(univ?.availableDestination) ? univ?.availableDestination : []).map((item: any, idx: number) => (
                                            <div key={idx} className="flex items-center gap-1 text-sm text-gray-700">
                                                <ImageWithBasePath
                                                    style={{ width: 32, height: 20 }}
                                                    source={item?.destinationCountry?.countryImage}
                                                    alt={item?.destinationCountry?.countryName}
                                                    // className="rounded-full"
                                                />
                                                <span>{item?.destinationCountry?.countryName}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                                <div className="mt-auto flex justify-center p-3">
                                    <Link
                                        to={route.Unlock}
                                        className="btn btn-danger btn-sm d-inline-flex items-center justify-center text-center"
                                        style={{ width: '200px', padding: '10px' }}
                                    >
                                        {univ?.buttonText}
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>


                {totalPages > 1 && (
                    <div className="py-6 flex justify-center cursor-pointer">
                        <Pagination currentPage={page} totalPages={totalPages} onPageChange={setPage} />
                    </div>
                )}

                {/* <div className="cursor-pointer bg-pink-500 p-4 text-white" onClick={() => alert('Clicked')}>
                    Test Click
                </div> */}

            </div>

        </>
    );
};

export default Whatsnew;
